export default __webpack_public_path__ + "static/media/ontario-trillium-foundation-logo.fcc92e59.jpg";